import { FC } from 'react';
import { ProButton } from '../antd';
import { BaseOperationButtonProps } from './interface';
import { ICON_COLLECTION } from '../constants/icon';

/** 删除按钮 */
const DeleteButton: FC<BaseOperationButtonProps> = props => {
  const { children, text, icon, ...restProps } = props;
  return (
    <ProButton icon={icon} {...restProps}>
      {children || text}
    </ProButton>
  );
};

DeleteButton.defaultProps = {
  icon: ICON_COLLECTION.DELETE,
  text: '删除',
};

export default DeleteButton;
